export function isNumber(value) {
    return (
        (typeof value === 'number' && !Number.isNaN(value)) ||
        (typeof value === 'object' && value instanceof Number && !Number.isNaN(value.valueOf()))
    );
}

export function get(object, path, defaultValue) {
    const keys = Array.isArray(path)
        ? path
        : path.replace(/\[(\d+)\]/g, '.$1').split('.');

    return keys.reduce((acc, key) => {
        if (acc && Object.prototype.hasOwnProperty.call(acc, key)) {
            return acc[key];
        }
        return undefined;
    }, object) ?? defaultValue;
}

export function ceil(number, precision = 0) {
    if (typeof number !== 'number' || typeof precision !== 'number') {
        return NaN;
    }

    const factor = Math.pow(10, precision);
    return Math.ceil(number * factor) / factor;
}

function normalizeUrl(url) {
    // If no protocol is present, prepend https://
    if (!/^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(url)) {
        return `https://${url}`;
    }
    return url;
}

export function isRootURL(url) {
    let rootUrl = false;

    try {
        const normalized = normalizeUrl(url);
        const aURL = new URL(normalized);
        const path = aURL.pathname;

        if (path === "" || path === "/") {
            rootUrl = true;
        }

        // BUT what if there are parameters afterwards?
        if (aURL.search && rootUrl) {
            console.debug(
                `url ${url} would have been considered a rootURL before TA15536..`
            );
            rootUrl = false;
        }
    } catch (e) {
        // Equivalent to catching MalformedURLException
        console.error(e);
        // Malformed URLs will be considered root url to avoid displaying them
        return true;
    }

    return rootUrl;
}

export const DEFAULT_ARTICLE_URL = "http://www.publicrelay.com/no-url-available/";

/**
 * Prevent to display "Web Link" if URL is default URL or a Root URL
 * @param url {string}
 * @returns {boolean}
 */
export const preventURLWebLink = (url) => {
    return DEFAULT_ARTICLE_URL === url || isRootURL(url);
}
